module.exports = __webpack_public_path__ + "img/seo_graphic.7e96130a.svg";